<button
  nz-button
  [nzType]="type"
  [nzShape]="shape"
  [nzSize]="size"
  [nzDanger]="danger"
  [disabled]="disabled"
  [nzLoading]="loading"
  [nzGhost]="ghost"
  [nzBlock]="block"
  (click)="onClick($event)"
>
  <i *ngIf="icon" nz-icon [nzType]="icon"></i>
  {{ text }}
</button>
